import { getCountryCodeByCallingCode } from '@/data/countries';
import { validateCPF } from '@/utils/validateCPF';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { z, ZodObject } from 'zod';

const cpfValidator = z
  .string()
  .refine((cpf) => !cpf.length || validateCPF(cpf), {
    message: 'CPF inválido.',
  });

const nameValidator = z
  .string()
  .min(1, { message: 'Nome completo é obrigatório.' });

const emailValidator = z.string().email({ message: 'Email inválido.' });

const phoneValidator = z.string().optional();

const CardFormSchema = z
  .object({
    cpf: cpfValidator.optional(),
    name: nameValidator,
    email: emailValidator,
    phone: phoneValidator,
    callingCode: z.string().min(1, { message: 'Insira um código válido' }),
  })
  .superRefine((data, ctx) => {
    const { phone, callingCode } = data;
    if (!phone) return true;

    const phoneNumberUtil = PhoneNumberUtil.getInstance();
    try {
      const regionCode = getCountryCodeByCallingCode(callingCode);
      const phoneNumber = phoneNumberUtil.parse(phone, regionCode);

      if (!phoneNumberUtil.isValidNumberForRegion(phoneNumber, regionCode)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Número de telefone inválido.',
        });
      }
    } catch (error) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Número de telefone inválido.',
      });
    }
  });

export type CardFormSchemaProps = z.infer<typeof CardFormSchema>;

export default CardFormSchema;
